<template>
  <b-popover
    :custom-class="`navigation_popover ${customPosition}`"
    :triggers="triggers"
    :target="target"
    :placement="placement"
    :offset="offset"
    :show.sync="show"
    boundary="viewport"
  >
    <header>{{ title }}</header>
    <button
      v-for="(item, index) in items"
      :key="`menu-item-${index}`"
      :class="item.selected ? 'selected' : ''"
      @click="handleItemClick(item)"
    >
      <div
        v-if="item.icon"
        class="icon"
      >
        <component
          :is="item.icon"
          class="icon"
        />
      </div>
      {{ $t(item.title) }}
    </button>
  </b-popover>
</template>

<script>
  import HomeIcon from '@/assets/icons/home-icon.svg';
  import { BPopover } from 'bootstrap-vue';
  export default {
    name: 'PopOver',
    components: { HomeIcon, BPopover },
    props: {
      title: { type: String, required: true },
      items: {
        type: Array,
        required: true
      },
      placement: {
        type: String,
        default: 'right'
      },
      triggers: {
        type: String,
        default: 'focus'
      },
      target: {
        type: String,
        required: true
      },
      offset: {
        type: Number,
        default: 0
      },
      customPosition: {
        type: String,
        default: null
      }
    },
    data: () => ({ show: false }),
    methods: {
      handleItemClick(item) {
        item.click();
        this.show = false;
      }
    }
  };
</script>

<style lang="scss">
  .navigation_popover {
    border: none !important;
    .arrow {
      display: none !important;
    }
    .popover-body {
      padding: 0 !important;
      width: inherit !important;
    }
    width: 180px !important;

    &.navbar {
      top: -3px !important;
      left: 40px !important;
    }

    &.sidebar {
      top: -20px !important;
    }
  }
</style>

<style lang="scss" scoped>
  .icon {
    width: 16px;
    height: 100%;
    margin-top: 1px !important;

    display: flex;
    justify-content: center;
    align-items: center;
  }
  .popover {
    display: flex;
    width: 100%;
    padding: 8px 0px;
    border-radius: 6px;
    background: #1a1c19;
    flex-direction: column;
    align-items: flex-start;
    box-shadow: 0px 7px 8px 0px rgba(0, 0, 0, 0.2), 0px 5px 22px 0px rgba(0, 0, 0, 0.12),
      0px 12px 17px 0px rgba(0, 0, 0, 0.14);

    header {
      padding: 12px 21px;
      font-size: 14px;
      font-weight: 600;
      color: #fff;
      height: 44px;
    }

    button {
      outline: 0;
      background: transparent;
      border: 0;
      cursor: pointer;

      width: 100%;
      padding: 10.5px 21px;

      display: flex;
      flex-direction: row;
      gap: 9px;

      font-size: 14px;
      font-weight: 400;

      border-top: 1px solid transparent;
      border-bottom: 1px solid transparent;

      color: #cfc4be;
      user-select: none;

      &:hover {
        border-bottom: 1px solid #974900;
        border-top: 1px solid #974900;
        background: rgba(151, 73, 0, 0.05);

        color: #fff !important;
      }

      &:active {
        border-top: 1px solid #974900;
        border-bottom: 1px solid #974900;
        background: rgba(151, 73, 0, 0.16);
      }
      &.selected {
        background: #974900;
        color: #fff !important;
      }
    }
  }
</style>
